"use client";

import classNames from "classnames";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import styles from "./navbar-button.module.scss";

type LinkProps = {
  link: string;
  name: string;
};

export const LinkBtn = ({ link, name }: LinkProps) => {
  const pathname = usePathname();

  //? If the segment after the first slash is the same as the link, then it is active
  const pathSegment = pathname?.split("/")[1];
  const activeLink = link.split("/")[1];

  //? If the link starts with "http", then it is an external link and thusly not active
  const isActive = activeLink === pathSegment && !link.startsWith("http");

  return (
    <Link href={link}>
      <button
        className={classNames(styles.navbarBtn, isActive && styles.activeLink)}
      >
        {name}
      </button>
    </Link>
  );
};
